module.exports = __webpack_public_path__ + "img/rocket.b2acaf7f.png";